module.exports = __webpack_public_path__ + "static/media/phone_blue_icon.99f2be07.svg";